import React from "react"
import { UncontrolledAlert } from "reactstrap"

import "./StatusPageIncidentAlert.scss"

class StatusPageIncidentAlert extends React.Component {
  constructor(props) {
    super(props)
    this.sp = null
    this.state = { unresolvedIncident: null }
  }

  updateIncidents() {
    // async loaded on startup into global namespace
    if (!window.StatusPage) {
      return
    }
    if (!this.sp) {
      this.sp = new window.StatusPage.page({ page: "g0v19sdmswx3" })
    }
    this.sp.incidents({
      filter: "unresolved",
      success: data => {
        const firstIncident = data.incidents.find(incident =>
          incident.incident_updates.find(incident_update =>
            incident_update.affected_components.some(
              // Code for asset-tracking.swipesense.com
              affected_component => affected_component.code === "rcyj0c26drs0"
            )
          )
        )
        this.setState({ unresolvedIncident: firstIncident })
      },
    })
  }

  componentDidMount() {
    this.status_interval = setInterval(() => this.updateIncidents(), 500000)
    this.updateIncidents()
  }

  componentWillUnmount() {
    if (this.status_interval) {
      clearInterval(this.status_interval)
      this.status_interval = false
    }
  }

  render() {
    if (!this.state.unresolvedIncident) {
      return null
    }
    return (
      <div className="StatusPageIncidentAlert">
        <UncontrolledAlert color={"warning"}>
          <h2>
            We've identified a {this.state.unresolvedIncident.impact} problem
          </h2>
          <p>
            SwipeSense is working on fixing a{" "}
            <a href={this.state.unresolvedIncident.shortlink}>
              {this.state.unresolvedIncident.name}
            </a>{" "}
            right now. If you're having issues with this page, we're working on
            it!
          </p>
        </UncontrolledAlert>
      </div>
    )
  }
}

export default StatusPageIncidentAlert
